import { Modal, useBreakpoint } from '@nextgen-web-framework/all';
import { ErrorModalProps } from './types/propTypes';

const ErrorModal = (props: ErrorModalProps) => {
  const viewPortType = useBreakpoint();
  const {
    header,
    primaryButtonLabel,
    secondaryButtonLabel,
    subHeader,
    primaryButton,
    containerWidth,
    secondaryButton,
    onClose,
    onSecondaryButtonClick,
    buttonAlignment,
    closeIcon,
  } = props;

  const defaultContainerWidth = ['xs', 'sm'].indexOf(viewPortType) !== -1 ? '21.4375rem' : '37.125rem';
  return (
    <div data-testid="error-modal-test-id">
      <Modal
        headline={header ?? ''}
        primaryButtonLabel={primaryButtonLabel ?? ''}
        secondaryButtonLabel={secondaryButtonLabel}
        onClose={onClose}
        primaryButton={primaryButtonLabel ? primaryButton : <> </>}
        secondaryButton={secondaryButtonLabel ? secondaryButton : <> </>}
        onPrimaryButtonClick={onClose}
        onSecondaryButtonClick={onSecondaryButtonClick}
        containerWidth={containerWidth ? containerWidth : defaultContainerWidth}
        buttonAlignment={buttonAlignment}
        closeIcon={closeIcon}
      >
        <>{subHeader}</>
      </Modal>
    </div>
  );
};

export default ErrorModal;
